import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  Button,
  FormControl,
  IconButton,
  Tooltip,
  Grid,
  Slider,
  CircularProgress,
  Popover,
  MenuItem,
} from "@mui/material";
// import { fetchLanguages } from "./VideoGenAPISettings";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import FaceIcon from "@mui/icons-material/Face";
import Face3Icon from "@mui/icons-material/Face3";
import { useWorkspace } from "../../../../contexts/WorkspaceContext";
import sourceUrl from "../../../../api/Source.api";
import { avatarVoiceLanguages } from "../../../../constants/avatarVoiceLanguages";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import Pagination from "@mui/material/Pagination";
import maleIcon from "../../../../assets/Icon/male.png";
import femaleIcon from "../../../../assets/Icon/female.png";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  DropdownForDIDLanguage,
  DropdownForGender,
  DropdownForVoices,
  DropdownForVoiceTone,
} from "../synthesiaSettings/DropDownButtons";
import MusicSettings from "../VideoGenSettings/MusicSettings";
import { FetchAllVoicesForHeygen } from "../../../../contexts/WorkspaceUtils";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CloseIcon from "@mui/icons-material/Close";

const LanguageArrayForFilter = [{ id: 0, name: "All", language: "All" }];

const VoiceToneArrayForFilter = [
  { id: 0, name: "All", description: "All" },
  { id: 2, name: "basic", description: "basic" },
];

const AccentArrayForFilter = [{ id: 0, value: "All", accent: "All" }];

const Voiceemotion = [
  "Excited",
  "Friendly",
  "Serious",
  "Soothing",
  "Broadcaster",
];
const Voicelocale = [
  "English (US)",
  "English (India)",
  "Serious",
  "Soothing",
  "Broadcaster",
];

const allFilterVoiceGender = [
  { id: 0, name: "All", gender: "" },
  { id: 1, name: "Male", gender: "male" },
  { id: 2, name: "Female", gender: "female" },
];

const LanguageAndVoiceForHeygen = (props) => {
  const {
    audioSettingVoices,
    setVideoVoice,
    languages,
    setLanguages,
    voices,
    setVoices,
  } = useWorkspace();
  const {
    selectedAvatarVoiceForHeygenVideo,
    setSeletedAvatarVoiceForHeygenVideo,
    allHeygenVideoVoiceList,
    setAllHeygenVideoVoiceList,
    voiceloading,
    setVoiceLoading,
    voiceEmotionForHeygen,
    setVoiceEmotionForHeygen,
    voicePitchForHeygen,
    setVoicePitchForHeygen,
    voiceSpeedForHeygen,
    setVoiceSpeedForHeygen,
  } = useWorkspace();
  const [filteredLanguages, setFilteredLanguages] =
    useState(avatarVoiceLanguages);
  const [filteredVoices, setFilteredVoices] = useState(allHeygenVideoVoiceList);
  const [languageOption, setLanguageOption] = useState(LanguageArrayForFilter);
  const [accentOption, setAccentOption] = useState(AccentArrayForFilter);
  const [playingVoice, setPlayingVoice] = useState(null);
  // const [audioElement, setAudioElement] = useState(null);
  const audioElement = useRef(null);
  const [currentPageForVoices, setCurrentPageForVoices] = useState(1);
  const [selectedDidVideoVoice, setselectedDidVideoVoice] = useState();
  const [currentWindow, setCurrentWindow] = useState(1);
  const [selectedHeygenVoiceEmotion, setSelectedHeygenVoiceEmotion] =
    useState("Excited");
  const [voiceSpeed, setVoiceSpeed] = useState(0);
  const [voicePitch, setVoicePitch] = useState(0);
  const [filterCriteria, setfilterCriteria] = useState({
    gender: "",
    language: "",
    accent: "",
  });
  const itemsPerPage = 20;
  const indexOfLastItem = currentPageForVoices * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredVoices?.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredVoices?.length / 20);
  const token = localStorage.getItem("token");
  const theme = localStorage.getItem("theme");

  console.log("currentItems", currentItems);

  const [currentpageItem, setCurrentPageItem] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(Math.floor(1379 / 10));
  const [gender, setGender] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  //   const getCurrentChunk = () => {
  //   const start = currentPage * 10;
  //   const end = start + 10;
  //   return allHeygenVideoVoiceList?.slice(start, end);
  // };

  //  useEffect(()=>{
  //   setCurrentPageItem(getCurrentChunk())
  //   setTotalPage(Math.floor(allHeygenVideoVoiceList?.length/10))
  //  },[currentPage])

  //  useEffect(() => {
  //    if (
  //      voiceloading == null &&
  //      (languages?.length === 0 || voices?.length === 0)
  //    ) {
  //     //  setVoiceLoading(true);
  //      fetchVoices();
  //    }
  //  }, []);

  const fetchHeygenVideoVoice = async () => {
    try {
      const heygenvoice = await FetchAllVoicesForHeygen(
        currentPage,
        gender?.gender
      );
      const response = await heygenvoice.json();
      if (response?.status) {
        console.log("response", response?.data?.data?.voices);
        setAllHeygenVideoVoiceList(response?.data?.data?.voices);
        setTotalPage(Math.floor(response?.data?.totalRows / 10));
      } else {
        console.log("error", response);
      }
    } catch (error) {
      console.error("HeygenVoiceError", error);
    } finally {
      setVoiceLoading(false);
    }
  };

  useEffect(() => {
    // if(!allHeygenVideoVoiceList?.length){
    setVoiceLoading(true);
    fetchHeygenVideoVoice();
    // }
  }, [currentPage, gender]);

  const HandleResetButtonClick = () => {
    setVoiceEmotionForHeygen("Friendly");
    setVoicePitchForHeygen(0);
    setVoiceSpeedForHeygen(1);
  };

  //  const fetchVoices = async () => {
  //    try {
  //      const response = await fetch(`${sourceUrl}/video/avatarVoice`, {
  //        headers: {
  //          Authorization: `Bearer ${token}`,
  //        },
  //      });

  //      if (!response.ok) {
  //        throw new Error("Failed to fetch voices");
  //      }
  //      const json = await response.json();
  //      const voiceData = json.data.data;
  //      setLanguages(avatarVoiceLanguages);
  //      setVoices(voiceData);
  //    } catch (error) {
  //      console.error("Error fetching voices:", error.message);
  //    }
  //    setVoiceLoading(false);
  //  };

  //  console.log("filterCriteria", filterCriteria);
  // console.log("currentItems", currentItems);

  //  useEffect(() => {
  //    function updateFilterArray(apiData, key, filterArray) {
  //      const existingValues = new Set(filterArray?.map((item) => item[key]));
  //      let currentId =
  //        filterArray.length > 0
  //          ? Math.max(...filterArray?.map((item) => item.id)) + 1
  //          : 1;

  //      const newValues = [];

  //      apiData?.forEach((item) => {
  //        // ✅ Check if key exists at the root level
  //        if (item[key] && !existingValues.has(item[key])) {
  //          existingValues.add(item[key]);
  //          newValues.push({
  //            id: currentId++,
  //            name: item[key],
  //            [key]: item[key],
  //          });
  //        }

  //        // ✅ Check if key exists inside `languages`
  //        if (item.languages) {
  //          item.languages
  //            .filter((lang) => lang[key]) // Ensure key exists
  //            .forEach((lang) => {
  //              const value = lang[key];
  //              if (value && !existingValues.has(value)) {
  //                existingValues.add(value);
  //                newValues.push({
  //                  id: currentId++,
  //                  name: value,
  //                  [key]: value,
  //                });
  //              }
  //            });
  //        }
  //      });

  //      return [...filterArray, ...newValues];
  //    }

  //    // Extract unique languages
  //    const updatedArray = updateFilterArray(
  //      allHeygenVideoVoiceList,
  //      "language",
  //      LanguageArrayForFilter
  //    );
  //    setLanguageOption(updatedArray);

  //    const updatedAccentArray = updateFilterArray(
  //      allHeygenVideoVoiceList,
  //      "accent",
  //      AccentArrayForFilter
  //    );
  //    setAccentOption(updatedAccentArray);
  //  }, [allHeygenVideoVoiceList]);

  //  useEffect(() => {
  //    const filteredData = allHeygenVideoVoiceList?.filter((item) => {
  //      const matchesLanguage =
  //        !filterCriteria.language ||
  //        item.languages?.some(
  //          (lang) => lang.language === filterCriteria.language
  //        ); // ✅ Check inside languages[]

  //      const matchesGender =
  //        !filterCriteria.gender ||
  //        (item.gender &&
  //          item.gender.toLowerCase() === filterCriteria.gender.toLowerCase());

  //      const matchesAccent =
  //        !filterCriteria.accent ||
  //        item.accent === filterCriteria.accent || // ✅ Check at root level
  //        item.languages?.some((lang) => lang.accent === filterCriteria.accent); // ✅ Check inside languages[]

  //      return matchesLanguage && matchesGender && matchesAccent;
  //    });

  //    const excludedData = allHeygenVideoVoiceList?.filter((item) => !filteredData.includes(item));
  //    const updatedVoices = filteredData?.concat(excludedData);

  //    setFilteredVoices(updatedVoices);
  //  }, [filterCriteria, voiceloading]);

  const handleVoiceSelectClick = (voiceOption) => {
    console.log("voiceOption", voiceOption);
    setSeletedAvatarVoiceForHeygenVideo(voiceOption);
    //  setselectedDidVideoVoice(voiceOption);
    setVideoVoice(voiceOption?.id);

    // Only update timeline items if the props are provided (from VideoGenerate.jsx)
    if (
      props.timelineItems &&
      typeof props.timelineItems === "function" &&
      props.activeTimelineItem !== undefined
    ) {
      props.timelineItems((prevItems) => {
        const items = [...prevItems];

        items[props.activeTimelineItem] = {
          ...items[props.activeTimelineItem],
          voice: voiceOption?.voice_id || voiceOption?.id,
        };

        return items;
      });
    }
  };

  const handleVoiceSelect = (voice) => {
    if (playingVoice === voice?.voice_id) {
      if (audioElement.current) {
        audioElement.current.pause();
        audioElement.current.currentTime = 0; // Reset audio to start
        audioElement.current = null;
      }
      setPlayingVoice(null);
    } else {
      if (audioElement.current) {
        audioElement.current.pause();
        audioElement.current.currentTime = 0; // Reset audio to start
        audioElement.current = null;
      }
      const newAudioElement = new Audio(voice?.preview_audio);

      // When audio ends, reset the playingVoice state
      newAudioElement.onended = () => {
        setPlayingVoice(null);
      };

      newAudioElement
        .play()
        .catch((error) => console.error("Playback error:", error));

      setPlayingVoice(voice?.voice_id);
      audioElement.current = newAudioElement;
    }
  };

  useEffect(() => {
    return () => {
      if (audioElement.current) {
        audioElement.current.pause();
        audioElement.current.currentTime = 0;
        audioElement.current.src = "";
        audioElement.current = null;
      }
      setPlayingVoice(null);
    };
  }, []);

  const handleClearButtonClick = () => {
    setfilterCriteria({
      gender: "",
      language: "",
      accent: "",
    });
  };

  //  const handlePageChange = (event, value) => {
  //    setCurrentPageForVoices(value); // Update the current page when a page is clicked
  //  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value); // Update the current page when a page is clicked
  };

  // Custom theme for Material UI Pagination
  const paginationTheme = createTheme({
    typography: {
      fontFamily: "Inter",
    },
    components: {
      MuiPagination: {
        styleOverrides: {
          root: {
            "& .MuiPaginationItem-root": {
              color: "#ffffff",
              borderRadius: "20px",
              "&:hover": {
                backgroundColor: "rgba(179, 168, 183, 0.26)",
              },
              fontSize: "14px",
            },
            "& .MuiPaginationItem-page.Mui-selected": {
              backgroundColor: "#CAC4D0",
              color: "black",
              "&:hover": {
                backgroundColor: "#CAC4D0",
              },
            },
            "& .MuiPaginationItem-ellipsis": {
              color: "#ffffff",
            },
            "& .MuiPaginationItem-previousNext": {
              color: "#ffffff",
              borderRadius: "20px",
            },
          },
        },
      },
    },
  });

  const handleSelectGender = (ele) => {
    setGender(ele);
    handleClose();
  };

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {currentWindow == 1 ? (
        <Box
          sx={{
            padding: "20px 20px 0px 0px",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              height: "100%",
              overflow: "hidden",
            }}
          >
            {/* <Box
              sx={{
                border: "",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Box>
                <Typography
                  variant="h6"
                  gutterBottom
                  style={{
                    fontSize: "16px",
                    fontWeight: "500",
                    marginBottom: "8px",
                    fontFamily: "Inter",
                    fontStyle: "normal",
                    lineHeight: "20px",
                    color: "#ffffff",
                  }}
                >
                  Video language
                </Typography>
                <Typography
                  //  gutterBottom
                  style={{
                    fontSize: "14px",
                    fontWeight: "400",
                    marginBottom: "20px",
                    fontFamily: "Inter",
                    fontStyle: "normal",
                    lineHeight: "20px",
                    color: "rgba(255, 255, 255, 0.80)",
                  }}
                >
                  Select the language for your video’s script
                </Typography>
              </Box>
              <Box sx={{ border: "" }}>
                <Button
                  onClick={() => {
                    setCurrentWindow(2);
                  }}
                  sx={{
                    display: "flex",
                    justifyContent: "space-around",
                    textTransform: "none",
                    // border: "1px solid rgba(255, 255, 255, 0.10)",
                    padding: "8px 12px 8px 12px",
                    gap: "10px",
                    bgcolor: "#282D51",
                    // marginLeft: "20px",
                    textWrap: "nowrap",
                    borderRadius: "8px",
                    "&:hover": { bgcolor: "#373E6D" },
                    "&:active": { bgcolor: "#2F355F" },
                  }}
                >
                  <Box
                    sx={{
                      width: "17px",
                      borderRadius: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      color: "#FFFFFF",
                    }}
                  >
                    <SettingsOutlinedIcon
                      sx={{ width: "18px", height: "18px" }}
                    />
                  </Box>
                  <Box
                    sx={{
                      height: "20px",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "Inter",
                        fontStyle: "normal",
                        fontSize: "14px",
                        fontWeight: 400,
                        lineHeight: "20px",
                        color: "#FFFFFF",
                      }}
                    >
                      Advanced settings
                    </Typography>
                  </Box>
                </Button>
              </Box>
            </Box>

            <Box sx={{ marginBottom: "40px" }}>
              <DropdownForDIDLanguage
                filteredLanguages={filteredLanguages}
                setFilteredLanguages={setFilteredLanguages}
              />
            </Box> */}
            <Box
              sx={{
                flexShrink: 0,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                marginBottom: "24px",
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Typography
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                    marginBottom: "8px",
                    fontFamily: "Inter",
                    fontStyle: "normal",
                    lineHeight: "20px",
                    color: "rgba(255, 255, 255, 1)",
                  }}
                >
                  AI Narrator
                </Typography>
                <Typography
                  style={{
                    fontSize: "14px",
                    fontWeight: "400",
                    fontFamily: "Inter",
                    fontStyle: "normal",
                    lineHeight: "20px",
                    color: "rgba(255, 255, 255, 0.80)",
                  }}
                >
                  Premium AI voices tailored to your content
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  columnGap: "12px",
                }}
              >
                <Button
                  onClick={handleOpen}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "8px",
                    color: gender?.name
                      ? "rgba(255, 255, 255, 1)"
                      : "rgba(202, 196, 208, 1)",
                    backgroundColor: open ? "#373E6D" : "#2F355F",
                    borderRadius: "8px",
                    height: "40px",
                    minWidth: "120px",
                    textTransform: "none",
                    fontFamily: "Inter",
                    fontWeight: 400,
                    "&:hover": {
                      backgroundColor: "#373E6D",
                    },
                    transition: "background-color 0.2s ease",
                  }}
                >
                  <span style={{ flex: 1, textAlign: "center" }}>
                    {gender?.name || "Gender"}
                  </span>
                  {open ? (
                    <CloseIcon
                      sx={{
                        color: gender?.id
                          ? "rgba(255, 255, 255, 1)"
                          : "rgba(202, 196, 208, 1)",
                        fontSize: "20px",
                      }}
                    />
                  ) : (
                    <ArrowDropDownIcon
                      sx={{
                        color: gender?.id
                          ? "rgba(255, 255, 255, 1)"
                          : "rgba(202, 196, 208, 1)",
                      }}
                    />
                  )}
                </Button>

                <Popover
                  open={open}
                  anchorEl={anchorEl}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  sx={{
                    "& .MuiPaper-root": {
                      backgroundColor: "#2F355F",
                      color: "white",
                      borderRadius: "8px",
                      boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
                      maxHeight: "300px",
                      width: "auto",
                      minWidth: "120px",
                      marginTop: "4px",
                    },
                  }}
                >
                  <Box
                    sx={{ overflowY: "auto", maxHeight: 250, padding: "4px" }}
                  >
                    {allFilterVoiceGender?.map((ele) => (
                      <MenuItem
                        key={ele.id}
                        onClick={() => handleSelectGender(ele)}
                        sx={{
                          "&:hover": { backgroundColor: "#373E6D" },
                          "&.Mui-selected": { backgroundColor: "#373E6D" },
                          py: 1,
                          px: 2,
                          fontSize: 14,
                          whiteSpace: "nowrap",
                        }}
                      >
                        {ele.name}
                      </MenuItem>
                    ))}
                  </Box>
                </Popover>

                <Box onClick={handleClearButtonClick}>
                  <Typography
                    sx={{
                      fontFamily: "Inter",
                      fontStyle: "normal",
                      fontSize: "14px",
                      fontWeight: 500,
                      lineHeight: "20px",
                      color: "#FFFFFF",
                      cursor: "pointer",
                    }}
                  >
                    {Object.values(filterCriteria).some(
                      (value) => value !== ""
                    ) && "Clear filters"}
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                flex: 1,
                overflow: "hidden",
                minHeight: 0,
                position: "relative",
              }}
            >
              {/* Top gradient border with blur effect */}
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  height: "1px",
                  background:
                    "linear-gradient(90deg, rgba(255, 255, 255, 0.02) 0%, rgba(255, 255, 255, 0.08) 20%, rgba(255, 255, 255, 0.12) 50%, rgba(255, 255, 255, 0.08) 80%, rgba(255, 255, 255, 0.02) 100%)",
                  zIndex: 2,
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    top: "1px",
                    left: 0,
                    right: 0,
                    height: "24px",
                    background:
                      "linear-gradient(180deg, rgba(31, 35, 63, 0.9) 0%, rgba(31, 35, 63, 0.6) 40%, transparent 100%)",
                    pointerEvents: "none",
                  },
                }}
              />
              <Box
                sx={{
                  width: "100%",
                  flex: 1,
                  overflowY: "auto",
                  display: "flex",
                  flexDirection: "column",
                  rowGap: "16px",
                  alignItems: "center",
                  paddingRight: "8px",
                  paddingTop: "16px",
                  "&::-webkit-scrollbar": {
                    width: "6px",
                  },
                  "&::-webkit-scrollbar-track": {
                    backgroundColor: "rgba(255, 255, 255, 0.05)",
                    borderRadius: "3px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "rgba(255, 255, 255, 0.2)",
                    borderRadius: "3px",
                    "&:hover": {
                      backgroundColor: "rgba(255, 255, 255, 0.3)",
                    },
                  },
                }}
              >
                {voiceloading ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    <CircularProgress
                      color="secondary"
                      size="30px"
                      style={{ color: "#ffffff" }}
                    />
                  </Box>
                ) : (
                  allHeygenVideoVoiceList &&
                  allHeygenVideoVoiceList?.map((voiceObj) => {
                    return (
                      <Box
                        onClick={() => handleVoiceSelectClick(voiceObj)}
                        sx={{
                          width: "100%",
                          border:
                            selectedAvatarVoiceForHeygenVideo?.name ===
                            voiceObj?.name
                              ? "1px solid rgba(255, 255, 255, 0.30)"
                              : "1px solid rgba(255, 255, 255, 0.10)",
                          padding: "12px 16px",
                          borderRadius: "16px",
                          display: "flex",
                          justifyContent: "space-between",
                          cursor: "pointer",
                          backgroundColor:
                            selectedAvatarVoiceForHeygenVideo?.name ===
                            voiceObj?.name
                              ? "#282D51"
                              : "transparent",
                          "&:hover": {
                            backgroundColor: "#282D51",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            textAlign: "center",
                          }}
                        >
                          <Tooltip
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  bgcolor: "#E6E0E9",
                                  color: "#17182C",
                                  fontFamily: "Inter",
                                  fontSize: "12px",
                                  fontWeight: 500,
                                  padding: "4px 8px 4px 8px",
                                  borderRadius: "4px",
                                  textAlign: "center",
                                },
                              },
                            }}
                            title={
                              playingVoice === voiceObj.voice_id
                                ? `Stop voice`
                                : `Preview voice`
                            }
                          >
                            <IconButton
                              disabled={!voiceObj?.preview_audio}
                              onClick={(e) => {
                                handleVoiceSelect(voiceObj);
                                e.stopPropagation();
                              }}
                              sx={{
                                color:
                                  playingVoice === voiceObj?.voice_id
                                    ? "rgba(23, 26, 45, 1)"
                                    : "rgba(23, 26, 45, 1)",
                                backgroundColor:
                                  playingVoice === voiceObj?.voice_id
                                    ? "white"
                                    : "white",
                                transition:
                                  "background-color 0.3s ease, transform 0.2s ease",
                                "&:hover": {
                                  backgroundColor: "white",
                                },
                                "&:disabled": {
                                  color: "rgba(230, 224, 233, 1)",
                                  bgcolor: "rgba(230, 224, 233, 0.12)",
                                },
                                width: "30px",
                                height: "30px",
                                padding: "12px",
                                borderRadius: "50%",
                              }}
                            >
                              {playingVoice === voiceObj?.voice_id ? (
                                <PauseIcon sx={{}} />
                              ) : (
                                <PlayArrowIcon sx={{}} />
                              )}
                            </IconButton>
                          </Tooltip>
                          <Box
                            sx={{
                              border: "1px solid rgba(255, 255, 255, 0.10)",
                              height: "30px",
                              margin: "0px 12px",
                            }}
                          ></Box>
                          <IconButton sx={{ padding: "0px" }}>
                            {voiceObj.gender === "male" ? (
                              <Box
                                component="img"
                                src={maleIcon}
                                alt="Male"
                                sx={{ width: 20, height: 20 }}
                              />
                            ) : voiceObj.gender === "female" ? (
                              <Box
                                component="img"
                                src={femaleIcon}
                                alt="Female"
                                sx={{ width: 20, height: 20 }}
                              />
                            ) : null}
                          </IconButton>
                          <Typography
                            sx={{
                              fontFamily: "Inter",
                              fontStyle: "normal",
                              fontWeight:
                                selectedAvatarVoiceForHeygenVideo?.name ===
                                voiceObj?.name
                                  ? 400
                                  : 500,
                              lineHeight: "20px",
                              letterSpacing: "0.1px",
                              fontSize: "14px",
                              color: "#fff",
                              marginLeft: "8px",
                            }}
                          >
                            {voiceObj?.name}
                          </Typography>
                        </Box>
                        {/* <Box
                       sx={{
                         display: "flex",
                         flexDirection: "row",
                         columnGap: "12px",
                       }}
                     >
                       {voiceObj?.accent ? (
                         <Tooltip
                           componentsProps={{
                             tooltip: {
                               sx: {
                                 bgcolor: "#E6E0E9",
                                 color: "#17182C",
                                 fontFamily: "Inter",
                                 fontSize: "12px",
                                 fontWeight: 500,
                                 padding: "4px 8px 4px 8px",
                                 borderRadius: "4px",
                                 textAlign: "center",
                               },
                             },
                           }}
                           title={`Accent: ${voiceObj?.accent}`}
                         >
                           <Button
                             sx={{
                               fontFamily: "Inter",
                               fontStyle: "normal",
                               fontSize: "14px",
                               fontWeight: 400,
                               lineHeight: "140%",
                               letterSpacing: "0.1px",
                               color: "rgba(255, 255, 255, 1)",
                               textWrap: "nowrap",
                               backgroundColor: "#2F355F",
                               width: "auto",
                               padding: "8px",
                               textTransform: "none",
                               whiteSpace: "nowrap",
                               borderRadius: "8px",
                             }}
                           >
                             {voiceObj?.accent}
                           </Button>
                         </Tooltip>
                       ) : null}
                       {voiceObj?.languages[0]?.language ? (
                         <Tooltip
                           componentsProps={{
                             tooltip: {
                               sx: {
                                 bgcolor: "#E6E0E9",
                                 color: "#17182C",
                                 fontFamily: "Inter",
                                 fontSize: "12px",
                                 fontWeight: 500,
                                 padding: "4px 8px 4px 8px",
                                 borderRadius: "4px",
                                 textAlign: "center",
                               },
                             },
                           }}
                           title={`Language: ${voiceObj?.languages[0]?.language}`}
                         >
                           <Button
                             sx={{
                               fontFamily: "Inter",
                               fontStyle: "normal",
                               fontSize: "14px",
                               fontWeight: 400,
                               lineHeight: "140%",
                               letterSpacing: "0.1px",
                               color: "rgba(255, 255, 255, 1)",
                               textWrap: "nowrap",
                               backgroundColor: "#2F355F",
                               width: "auto",
                               padding: "8px",
                               textTransform: "none",
                               whiteSpace: "nowrap",
                               borderRadius: "8px",
                             }}
                           >
                             {voiceObj?.languages[0]?.language}
                           </Button>
                         </Tooltip>
                       ) : null}
                     </Box> */}
                      </Box>
                    );
                  })
                )}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "12px",
                  paddingTop: "12px",
                  paddingBottom: "8px",
                  borderTop: "1px solid rgba(255, 255, 255, 0.05)",
                  flexShrink: 0,
                  position: "relative",
                  "&::after": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    height: "1px",
                    background:
                      "linear-gradient(90deg, rgba(255, 255, 255, 0.01) 0%, rgba(255, 255, 255, 0.04) 20%, rgba(255, 255, 255, 0.06) 50%, rgba(255, 255, 255, 0.04) 80%, rgba(255, 255, 255, 0.01) 100%)",
                  },
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: "-24px",
                    left: 0,
                    right: 0,
                    height: "24px",
                    background:
                      "linear-gradient(0deg, rgba(31, 35, 63, 0.5) 0%, rgba(31, 35, 63, 0.3) 60%, transparent 100%)",
                    pointerEvents: "none",
                  },
                }}
              >
                <ThemeProvider theme={paginationTheme}>
                  <Pagination
                    count={totalPage}
                    page={currentPage}
                    siblingCount={1}
                    boundaryCount={1}
                    onChange={handlePageChange}
                    shape="rounded"
                    size="large"
                  />
                </ThemeProvider>
              </Box>
            </Box>
          </Box>
          {/* )} */}
        </Box>
      ) : (
        <Box sx={{ padding: "20px 20px 0px 0px" }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Box
              sx={{ display: "flex", flexDirection: "row", columnGap: "12px" }}
            >
              <ArrowBackIcon
                sx={{ cursor: "pointer" }}
                onClick={() => {
                  setCurrentWindow(1);
                }}
              />
              <Typography>Advanced voice settings</Typography>
            </Box>
            <Box>
              <Button
                onClick={HandleResetButtonClick}
                sx={{
                  color: "#ffffff",
                  fontFamily: "Inter",
                  fontStyle: "normal",
                  fontWeight: 500,
                  display: "flex",
                  textTransform: "none",
                  lineHeight: "20px",
                }}
              >
                Reset to defaults
              </Button>
            </Box>
          </Box>
          <Box sx={{ mt: 3, maxWidth: "160px", width: "100%" }}>
            <Typography>Voice speed</Typography>
            <Box>
              <Slider
                value={voiceSpeedForHeygen}
                onChange={(e) => {
                  setVoiceSpeedForHeygen(e.target.value);
                }}
                min={0.01}
                max={1.5}
                step={0.01}
                aria-label="Music Volume"
                valueLabelDisplay="auto"
                sx={{
                  marginTop: "20px",
                  color: "white", // This sets the color for the active (left) track and thumb
                  "& .MuiSlider-thumb": {
                    backgroundColor: "white", // Thumb color to white
                    border: "2px solid white", // Optional border for better visibility
                  },
                  "& .MuiSlider-track": {
                    backgroundColor: "white", // Left side of the slider track
                  },
                  "& .MuiSlider-rail": {
                    backgroundColor: "gray", // Right side of the slider track
                  },
                }}
              />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "14px",
                    fontWeight: 400,
                  }}
                >
                  0.01
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "14px",
                    fontWeight: 400,
                  }}
                >
                  1.50
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box sx={{ mt: 3, maxWidth: "160px", width: "100%" }}>
            <Typography>Voice pitch</Typography>
            <Box>
              <Slider
                value={voicePitchForHeygen}
                onChange={(e) => {
                  setVoicePitchForHeygen(e.target.value);
                }}
                min={-50}
                max={50}
                step={1}
                aria-label="Music Volume"
                valueLabelDisplay="auto"
                sx={{
                  marginTop: "20px",
                  color: "white", // This sets the color for the active (left) track and thumb
                  "& .MuiSlider-thumb": {
                    backgroundColor: "white", // Thumb color to white
                    border: "2px solid white", // Optional border for better visibility
                  },
                  "& .MuiSlider-track": {
                    backgroundColor: "white", // Left side of the slider track
                  },
                  "& .MuiSlider-rail": {
                    backgroundColor: "gray", // Right side of the slider track
                  },
                }}
              />
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "14px",
                    fontWeight: 400,
                  }}
                >
                  -50
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Inter",
                    fontSize: "14px",
                    fontWeight: 400,
                  }}
                >
                  50
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box sx={{ mt: 3 }}>
            <Typography>Voice emotion</Typography>
            <Box
              container
              spacing={2}
              mt={2}
              justifyContent="start"
              sx={{ display: "flex", flexDirection: "row", columnGap: "12px" }}
            >
              {Voiceemotion?.map((emotion, index) => (
                <Box item key={emotion} sx={{}}>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setVoiceEmotionForHeygen(emotion);
                    }}
                    sx={{
                      // width: "54px",
                      // height: "32px",
                      textTransform: "none",
                      backgroundColor:
                        voiceEmotionForHeygen === emotion
                          ? "#3a3f69"
                          : "#30355f",
                      // backgroundColor: theme === 'dark'? '#30355f' : '',
                      color: theme === "dark" ? "white" : "black",
                      "&:hover": {
                        backgroundColor: "#373E6D",
                        border: " 1px solid #373E6D",
                      },
                      borderColor:
                        voiceEmotionForHeygen === emotion
                          ? "#cac4d0"
                          : "transparent",
                      mx: 0.5, // Add horizontal margin for spacing
                    }}
                  >
                    {emotion}
                  </Button>
                </Box>
              ))}
            </Box>
          </Box>
          {/* <Box sx={{mt:3}}>
        <Typography>Voice locale</Typography>
        <Box sx={{display:"flex", flexDirection:"row", columnGap:"12px"}} container mt={2} justifyContent="start">
          {Voicelocale?.map((emotion, index) => (
            <Box item key={emotion}>
              <Button 
                variant="outlined"
                // onClick={() => handleVideoRatio(videoratio)}
                sx={{
                    textWrap:"nowrap",
                  width: "auto",
                  // height: "32px",
                  textTransform:"none",
                  backgroundColor:
                  selectedHeygenVoiceEmotion === emotion ? "#3a3f69" : "#30355f",
                  // backgroundColor: theme === 'dark'? '#30355f' : '',
                  color: theme === "dark" ? "white" : "black",
                  "&:hover": {
                    backgroundColor: "#373E6D", 
                    border:" 1px solid #373E6D"
                  },
                  borderColor:
                  selectedHeygenVoiceEmotion === emotion
                      ? "#cac4d0"
                      : "transparent",
                  mx: 0.5, // Add horizontal margin for spacing
                }}
              >
                {emotion}
              </Button>
            </Box>
          ))}
        </Box>
        </Box> */}
        </Box>
      )}
    </>
  );
};

export default LanguageAndVoiceForHeygen;
